import React,{useState} from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../../atoms/checkBox/Checkbox';
import { PromotionStyle } from './PlanTypeStyle';

const PlanTypeItem = (props) => {
    let [check, setCheck] = useState(false);
    const handlePlanTypeCheck = (event) => {
        let flag=event.target.checked;
        setCheck(flag)
        props.plantypeClickHandler(flag)
    }
    const checkFilteredPromotion = () => {
        return props.filteredPlanType.filter(brand => brand.value === props.plantype.value).length > 0 ? true : false
    }

    return (
        <ul className='list'>
            <li>
                <Checkbox
                isChecked={
                    props?.filteredPlanType?.length > 0 ? checkFilteredPromotion() :
                    props?.filteredPlanType?.length === 0 ? false : check
                }
                id={`${props.plantype.label}`}
                check={`${props.plantype.label} `}
                click={handlePlanTypeCheck}
                />
            </li>
            <style jsx>{PromotionStyle}</style>
        </ul>
    );
};

PlanTypeItem.propTypes = {
    promotion: PropTypes.object,
    filteredPromotions: PropTypes.array,
    promoClickHandler: PropTypes.func,
    plantypeClickHandler: PropTypes.func,
    filteredPlanType: PropTypes.array,
    plantype: PropTypes.object
};

export default PlanTypeItem;

